<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"><HeaderContent /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 动态详情 -->
      <div class="dynamic_details">
        <h1>柳州市柳北区委书记刘俊等一行领导莅临桅灯智能长沙总部考察</h1>
        <p style="margin: 10px 0">2021-09-14</p>

        <p>
          2021年9月14日下午，湖南桅灯智能科技有限公司迎来广西柳州市柳北区委书记刘俊、柳北区委副书记梁敏娟、柳北区委常委、区委办主任钟庆林等一行领导。公司相关负责人龙照凯总热情接待，并陪同领导参观湖南桅灯总部。
        </p>
        <br />
        <div>
          <img style="max-width: 100%" src="~@/assets/images/kaochaweid.png" />
        </div>
        <br />
        <!-- <p>
          物联网的发展随着5G技术的落地和实现进入一个新高度，行业也翻起了阵阵波浪。从智能家居到智慧城市，互联网巨头和技术型企业前仆后继。
        </p>
        <br /><br />
        <p>
          WIDEN桅灯智能便是千万企业中的一家，2017年12月成立的WIDEN桅灯智能，三年不到时间，融资3轮，并且获得京东方A轮融资。其主要智能中枢系统CNS平台，为公共空间的智能化提供配套解决方案，上线一年不到便实现超亿营收。
        </p> -->
        <p>
          走进桅灯智能科技有限公司，各位领导首先了解到，这是一家专注公共空间智慧建筑领域运用物联网人工智能技术的科技公司，龙照凯总详细汇报了公司CNS智能中枢产品的运行原理、技术先进性、产品推广现状以及国内市场前景，期间刘书记就产品科技创新以及未来公司发展方向等问题点进行询问，龙照凯总一一解答。
        </p>
        <br />
        <p>
          最后，刘书记对我公司核心技术领域表示充分的肯定，希望以后能够有合作的机会与家乡企业进行对接，以期实现企业双方及社会效应的共赢。
        </p>
        <br />
      </div>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  background: #f8fafc;
  .dynamic_details {
    margin: 62px 260px 53px 260px;
    padding: 55px 67px 74px 61px;
    background: #fff;
    text-align: left;
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 16px;
      line-height: 32px;
    }

    div {
      text-align: center;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .main_content {
    .dynamic_details {
      margin: 62px 8% 53px 11.5%;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>